import axiosInstance from "../../../../lib/axiosInstance";

const detailMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  return typeof detail === "string" ? detail : JSON.stringify(detail);
};

export const listCombinations = async () => {
  try {
    const { data } = await axiosInstance.get("/propulsion/combinations");
    return data.combinations || [];
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load combinations"));
  }
};

export const getCombination = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/propulsion/combinations/${id}`);
    return data; // { combination, motor, propeller, esc, battery, points, has_measured }
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load combination"));
  }
};

export const simulate = async (payload) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/simulate", payload);
    return data; // { combination, inputs, result }
  } catch (error) {
    throw new Error(detailMessage(error, "Simulation failed"));
  }
};

export const getCatalog = async () => {
  try {
    const { data } = await axiosInstance.get("/propulsion/catalog");
    return data; // { motors, propellers, escs, batteries }
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load catalog"));
  }
};

export const createCombination = async (payload) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/combinations", payload);
    return data.combination; // saved combination row
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to save combination"));
  }
};

// Catalog part writes. `type` is one of motor | propeller | esc | battery;
// the backend returns the saved row under that same key.
const PART_ENDPOINTS = {
  motor: "/propulsion/motors",
  propeller: "/propulsion/propellers",
  esc: "/propulsion/escs",
  battery: "/propulsion/batteries",
};

export const createPart = async (type, payload) => {
  const url = PART_ENDPOINTS[type];
  try {
    const { data } = await axiosInstance.post(url, payload);
    return data[type]; // saved part row
  } catch (error) {
    throw new Error(detailMessage(error, `Failed to add ${type}`));
  }
};

// Drones (airframes) + their associated motors.
export const listDrones = async () => {
  try {
    const { data } = await axiosInstance.get("/propulsion/drones");
    return data.drones || [];
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load drones"));
  }
};

export const createDrone = async (payload) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/drones", payload);
    return data.drone; // saved drone row incl. `motors`
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to add drone"));
  }
};
